import React from "react";
import { FadeIn } from "./FadeIn";

// The recurring brand signature: small-caps eyebrow, Oxblood hairline,
// then (optionally) an italic section title beneath.
export const Signature = ({ label, title, reversed = false, testid }) => {
  const ruleColor = reversed ? "#B0573F" : "#7A2E2E";
  const labelColor = reversed ? "#B0573F" : "#7A2E2E";
  const titleColor = reversed ? "#F4F1EA" : "#1C1A17";
  return (
    <FadeIn className="mb-10 md:mb-14" data-testid={testid}>
      <p
        className="text-[11px] uppercase tracking-[0.3em]"
        style={{ color: labelColor }}
      >
        {label}
      </p>
      <hr
        className="mt-5 mb-0 border-0"
        style={{ width: "72px", height: "0.75px", backgroundColor: ruleColor }}
      />
      {title && (
        <h2
          className="mt-7 text-[24px] md:text-[26px] italic leading-snug"
          style={{ color: titleColor }}
        >
          {title}
        </h2>
      )}
    </FadeIn>
  );
};
